import dayjs from 'dayjs';
import 'dayjs/locale/es';
import i18n from './i18n';

dayjs.locale(i18n.language || 'es');
